import(/* webpackMode: "eager" */ "/codebuild/output/src1090216177/src/apps/junonkuji/src/app/error.tsx");
